import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-inscrip-header',
  templateUrl: './inscrip-header.component.html',
  styleUrls: ['./inscrip-header.component.css']
})
export class InscripHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
